import { useMutation } from '@tanstack/react-query';
import { getCallAudio as getCallAudioService } from 'services/api/getCallAudio';

export const useGetCallAudio = () => {
    const {
        mutateAsync: getCallAudio,
        isPending,
        error,
    } = useMutation({
        mutationFn: getCallAudioService,
    });

    return { getCallAudio, isCallAudioLoading: isPending, error };
};
